/**
 * Formatering av tall i norsk konvensjon.
 *
 * Beløp i bolig-prosjekter er typisk i millioner, så vi viser MNOK med
 * 1 desimal opp til 9.9, deretter heltall. For < 1 MNOK viser vi "X kNOK".
 */
const nbNumber = new Intl.NumberFormat("nb-NO", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const nbInt = new Intl.NumberFormat("nb-NO", {
  maximumFractionDigits: 0,
});

export function formatNok(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (value === 0) return "0";
  const mnok = value / 1_000_000;
  if (Math.abs(mnok) >= 1) {
    return `${nbNumber.format(mnok)} MNOK`;
  }
  const knok = value / 1_000;
  return `${nbInt.format(knok)} kNOK`;
}

export function formatNokCompact(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (value === 0) return "—";
  const mnok = value / 1_000_000;
  if (Math.abs(mnok) >= 1) {
    return `${nbNumber.format(mnok)}M`;
  }
  return `${nbInt.format(value / 1_000)}k`;
}

/**
 * NOK i MNOK, kun tallet — uten enhets-suffix.
 * Brukes når enheten allerede står i label (eks. "Salgsverdi (MNOK)").
 */
export function formatMNOK(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return nbNumber.format(value / 1_000_000);
}
